<template lang="pug">
    .employee(:class="layout")
        Person(
            :content="person",
            :region="region",
            :images="image",
            :showIcons="showIcons",
            :layout="layout"
        )
</template>

<script>
//import { get } from '@/helpers';
import Person from './Person';

export default {
    name: 'ContactPerson',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Person
    },
    computed: {
        contents() {
            return this.section.contents || [];
        },
        person() {
            return this.contents.find(content => content.key === 'content');
        },

        region() {
            return this.contents.find(content => content.key === 'region');
        },
        image() {
            return this.contents.find(content => content.key === 'image');
        },

        layout() {
            let layout = 'oneCol';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'layout');
                if (setting && setting.value !== undefined) layout = setting.value;
            }
            return layout;
        },
        showIcons() {
            let showIcons = false;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'showIcons');
                if (setting && setting.value !== undefined) showIcons = setting.value;
            }
            return showIcons;
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
</style>
